import React from 'react';
import { Place } from '../../../../models/Place';
import PlaceBookmark from '../BookmarkItems/PlaceBookmark';
import { BookmarkListContainer } from '../bookmarkStyles';

type PlaceBookmarkProps = {
	places: Place[];
};
const PlaceBookmarks: React.FC<PlaceBookmarkProps> = ({ places }) => {
	return (
		<BookmarkListContainer>
			{places.map((place) => {
				return <PlaceBookmark key={place.id} place={place} />;
			})}
		</BookmarkListContainer>
	);
};

export default PlaceBookmarks;
